e.login_modal = {
	init : function(){
		$( '.'+config.login_modal_trigger_class ).click( function(){
			e.login_modal._display_modal( $(this) );
		});

		$('body').on( 'click', '.show-hide-password', this._show_hide_password );
	},

	/**
	 * Turn the password field of the login form to text or back to password
	 * A link within the login modal gets clicked and the state is retrieved
	 *
	 * @private
	 */
	_show_hide_password : function(){
		var $el = $(this);
		if( $el.data( 'state' ) == 'hide' ){
			$('#user_pass' ).attr( 'type', 'text' );
			$el.text( $el.data( 'hide' ) );
			$el.data( 'state', 'show' );
		} else {
			$('#user_pass' ).attr( 'type', 'password' );
			$el.text( $el.data( 'show' ) );
			$el.data( 'state', 'hide' );
		}
	},

	_display_modal : function( el ){
		$.get( config.login_modal_url, function( $content ){
			var $template = Handlebars.compile( $content );
			e.el.body.append( $template( { url : el.data( 'url' ) } ) );

			tb_show( config.i18n.login, "#TB_inline?width=600&height=550&inlineId=login" );
		});
	}
};